import { useResponsive } from '@sg/garnish';

import {
  MODAL_SCREEN_OPTIONS,
  TRANSPARENT_MODAL_SCREEN_OPTIONS,
} from '../../options';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns responsive modal screen options.
 * - XS: `modal` presentation (fullscreen card).
 * - SM+: `transparentModal` presentation (overlay on top of existing content).
 */
export const useModalScreenOptions = () => {
  const { currentBreakpoint } = useResponsive();

  return currentBreakpoint.isXS
    ? MODAL_SCREEN_OPTIONS
    : TRANSPARENT_MODAL_SCREEN_OPTIONS;
};
